module.exports = __webpack_public_path__ + "static/media/scrum.f6fb989e.png";